import Bowser from 'bowser';
import type { FC, ReactNode } from 'react';
import { useEffect, useState } from 'react';

import { Dialog } from '@zen/DesignSystem';

import OutdatedBrowserImage from './outdated-browser.svg?react';

const OutdatedBrowser: FC = () => {
  const [isValidBrowser, setIsValidBrowser] = useState<boolean>(true);
  const [closed, setClosed] = useState<boolean>(false);

  const message: ReactNode = (
    <div>
      <div className="flex justify-center mt-4 mb-2">
        <OutdatedBrowserImage className="w-56" />
      </div>
      <div>
        Your web browser is outdated, some features will not work. We strongly recommend you to upgrade or change browser.
      </div>
    </div>
  );

  const checkBrowser = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const isValid = browser.satisfies({
      // declare browsers per OS
      windows: {
        'internet explorer': '>11',
        edge: '>88'
      },
      macos: {
        safari: '>14'
      },

      // per platform (mobile, desktop or tablet)
      mobile: {
        safari: '>14',
        'android browser': '>109'
      },

      // or in general
      chrome: '>88',
      chromium: '>88',
      edge: '>88',
      firefox: '>82',
      opera: '>74'
    });

    setIsValidBrowser(!!isValid);
  };

  useEffect(() => {
    checkBrowser();
  }, []);

  if (isValidBrowser || closed) {
    return null;
  }

  const close = () => setClosed(true);

  return (
    <Dialog
      confirmLabel="OK, got it"
      hasCancelButton={false}
      header="Please upgrade your browser"
      isOpen={true}
      message={message}
      onClose={close}
      onConfirm={() => setClosed(true)}
    />
  );
};

export default OutdatedBrowser;
